import React, { useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { handleError } from "../../Common/ApiCommon/ApiService";
import { deleteComboOffer } from "./ComboSlice";

const DeleteCombo = ({ isOpen, onClose, comboID }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dispatch = useDispatch();

    const handleDeleteItem = async () => {
        setIsSubmitting(true);
        try {
            await dispatch(deleteComboOffer(comboID)).unwrap();
            onClose();
            toast.success("Combo deleted successfully!", { duration: 2000 });
        } catch (errors) {
            handleError(errors);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 w-[310px] sm:w-[350px] h-auto shadow-lg relative">
                <p className="text-lg font-semibold mb-8 text-center">
                    Are you sure you want to delete this combo?
                </p>
                <div className="flex justify-center gap-4 mt-4">
                    <button
                        className="w-[75px] sm:w-[93px] py-2 text-center text-sm bg-white text-green rounded-lg border border-green"
                        onClick={onClose}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${isSubmitting ? "bg-green50 cursor-not-allowed" : "bg-green text-white"
                            }`}
                        disabled={isSubmitting}
                        onClick={handleDeleteItem}
                    >
                        {isSubmitting ? "Deleting..." : "Confirm"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteCombo;
